import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  controls: "",
  style: {width: '100%'}
}
const _hoisted_2 = ["src"]

import Api from "@/services/api"
    import { Video } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"

    // eslint-disable-next-line no-undef
    
export default /*@__PURE__*/_defineComponent({
  __name: 'VideoView',
  props: {
    video: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    // eslint-disable-next-line no-undef
    const emit = __emit

    const video = reactive<Video>({
        title: props.video.title,
        description: props.video.description,
        path: props.video.path,
        id: props.video.id
    })

    const rules = reactive<FormRules<Video>>({
        title: [{required: true, message: 'Insira o título do vídeo', min: 1}],
        description: [{required: true, message: 'Informe a descrição'}],
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(false)

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = new FormData()
                data.append('title', video.title)
                data.append('description', video.description)
                
                const res = await Api.put('admin/videos/' + video.id, video, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Video cadastrado com sucesso'})
                    emit("update")
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    loading: loading.value,
    animated: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        disabled: saving.value,
        rules: rules,
        model: video,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "title",
            label: "Título do vídeo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "title",
                type: "text",
                modelValue: video.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((video.title) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (video.path)
            ? (_openBlock(), _createElementBlock("video", _hoisted_1, [
                _createElementVNode("source", {
                  src: `${_unref(Api).publicUrl}alt-storage?path=videos/${video.path}`
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "Descrição",
            prop: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                name: "description",
                modelValue: video.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((video.description) = $event)),
                minlength: "1"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            loading: saving.value,
            size: "large",
            type: "primary",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Atualizar ", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["disabled", "rules", "model"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})